import { toDigits } from '@imprint-payments/imprint-lib/dist/utilities/toDigits';

import { ApiRequestV2, httpRequestV2 } from '../http/client';
import { Method } from '../http/httpConsts';

export interface CheckoutRequest {
  phone: string;
  productUUID: string;
}

export interface CheckoutResponse {
  status?: string;
  applicationState?: string;
  availableRewards?: AvailableRewards;
}

interface AvailableRewards {
  displaySymbol: string;
  displayValue: string;
  displayUnit: string;
  exponent: number;
  valueInMinUnit: number;
  negative: string;
}

export interface CheckoutError {
  code: string;
  message: string;
}

/**
 *
 * @param phone - non-numeric characters will be filtered before sending the request
 * @param productUUID
 */
export const checkout = async ({
  phone,
  productUUID,
}: CheckoutRequest): Promise<CheckoutResponse> => {
  const req: ApiRequestV2 = {
    path: '/v2/consumer/checkout',
    method: Method.POST,
    body: {
      phone: toDigits(phone),
      productUUID,
    },
  };
  return httpRequestV2(req);
};
